import * as PIXI from "pixi.js"
import Tween from "tween.ts";
import Animation from "./Animation";

type ElmEnum = PIXI.Graphics | PIXI.Text | PIXI.Sprite;

export default class OpacityAnimation extends Animation {
  constructor(elm: ElmEnum, sOpacity: number, tOpacity: number, duration: number, onComp: () => void){
    super();
		
		const opacity = { alpha: sOpacity };
		
		new Tween.Tween({...opacity})
		.to({alpha: tOpacity}, duration)
		.easing(Tween.Easing.Linear.None)
		.onUpdate(o => elm.alpha = o.alpha)
		.onComplete(() => onComp())
		.start()
  }
}